import { isDevOrLocalhost } from "@/basa/utils";

/***
 * 全局判断配置中心
 * ***/
const CONFIG = {
  parentId: isDevOrLocalhost() ? "100001" : "100002", // 配置组织根节点id
  duration: 3000, //后端返回错误提示框自动关闭事件 0为不自动关闭
  requestDuration: 1000, //拒绝前端连续请求 间隔为1s
  axiosTimeOut: 60000, //axios超时时间
  isMenuMock: true, //是否适用mock菜单
  faqId: 371, //供应商操作流程接口入参
  agentId: 100121,
  /**
   * 多语言配置
   * */
  i18n: {
    cookieLable: "language",
    // 默认语言
    default: "zh-cn", // 中文 zh-CN  英语 en-gb
    // 是否根据用户电脑配置自动设置语言（仅第一次有效）
    auto: false
  }
};

export default CONFIG;
export let commonTableWidth = {
  serialNoWidth: 50, //序号
  checkboxWidth: 55, //复选框
  telWidth: 110, //手机号
  dateWidth: 150, // 年月日时间宽度
  dateTimeWidth: 170, // 年月日时分秒时间宽度
  unitName: 200, // 单位
  supplierName: 200 // 供应商名称
};
export let pageTableWidth = {
  dateWidth: 150, // 年月日时间宽度
  dateTimeWidth: 170 // 年月日时分秒时间宽度
};
export let opCloWidth = {
  purchaseschemeCompileList: 220, // 方案编制列表操作宽度
  approvalQueryList: 50, // 方案审批列表操作宽度
  purchaseSchemeConfirmList: 50, // 方案确认列表操作宽度
  agreementMaintainList: 220 //  框架协议维护列表操作宽度
};
// 采购方案表格宽度统一配置
export let schemeColWidth = {
  schemeCode: 200, //设备物资编码
  schemeName: 150 // 设备物资名称
};

//设备物资表格列宽度
export let codePlatColWidth = {
  matcodeNum: 120, //设备物资编码
  matcodeName: 220 // 设备物资名称
};

//框架协议表格列宽度
export let agrColWidth = {
  matcodeName: 380, //协议编号
  protocolName: 200 //协议名称
};
//任务表格列宽度
export let taskColWidth = {
  taskCode: 200 //任务编号
};
// 详情页样式控制器
export let detailDomStyle = {
  style01: "detail-box ccui-clearfix", // 有右侧 有底部
  style02: "detail-box2 ccui-clearfix", // 有右侧 无底部
  style03: "detail-box3 ccui-clearfix", // 没有右侧 有底部
  style04: "detail-box4 ccui-clearfix" // 没有右侧 无底部
};
export let operState = {
  1: "approving",
  2: "approvaled"
};
export let schemeOperState = {
  1: "approving",
  2: "unapproval",
  3: "approvaled",
  4: ""
};
export let taskOperState = {
  1: "approving",
  2: "unapproval",
  3: "approvaled",
  4: ""
};

export let question_faqClassifyId = {
  "zh-cn": 1163,
  "en-gb": 158,
  "fr-fr": 169,
  "es-es": 166,
  "ru-ru": 170,
  ar: 172
};
